export function getPricingURL(instanceId) {
  return 'https://baserow.io/get-license/' + instanceId + '/'
}
